export const Types = {
  GET_LIST_DESEMPENHO: "desempenho/GET_LIST_DESEMPENHO",
  GET_LIST_DESEMPENHO_SUCCESS: "desempenho/GET_LIST_DESEMPENHO_SUCCESS",
  SET_GRAPH_DESEMPENHO: "desempenho/SET_GRAPH_DESEMPENHO"
};

const INITIAL_STATE = {
  data: []
};

export default function desempenho(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_DESEMPENHO:
      return { ...state };
    case Types.GET_LIST_DESEMPENHO_SUCCESS:
      return {
        ...state,
        data: action.payload.data
      };
    default:
      return state;
  }
}

export const Creators = {
  getListDesempenho: filtro => ({
    type: Types.GET_LIST_DESEMPENHO,
    payload: { filtro }
  }),
  getListDesempenhoSuccess: data => ({
    type: Types.GET_LIST_DESEMPENHO_SUCCESS,
    payload: { data }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/desempenho.js